<script>
import Trees from "../components/trees.vue";
import AppBar from "../layouts/home/AppBar.vue"
import firebase from "firebase/compat/app";
import LoginComponent from "@/components/Auth/Login";
import SignupComponent from "@/components/Auth/Signup";
import ExploreItems from "../components/ExploreItems.vue";
import RequestsCarousel from "../components/Home/requestsCarousel.vue";
import AppVue from '../App.vue';
// import HowItWorks from "../components/HowItWorks.vue";

export default {
  name: "Home",

  metaInfo: {
    title: "Strapp - Home 🏠",
    titleTemplate: "Strapp - Home 🏠",
    htmlAttrs: { lang: "en" },
    meta: [
      {
        name: "description",
        content:
          "Strapp is an online rental marketplace where you can rent out your household items and equipment to others for short term periods.",
      },
    ],
  },

  components: {
    AppBar,
    LoginComponent,
    SignupComponent,
    Subscribe: () => import("@/components/Subscribe"),
    CustomerReviews: () => import("@/components/CustomerReviews"),
    Trees,
    ExploreItems,
    RequestsCarousel,
    // HowItWorks
  },

  data: () => ({
    loginDialog: false,
    signupDialog: false,
    features: [
      {
        src: require("@/assets/fontawesome/circle-1-light.svg"),
        title: "Add a new listing",
        description:
          "Add a new rental listing and fill in details about the item",
      },
      {
        src: require("@/assets/fontawesome/circle-2-light.svg"),
        title: "Booking Request",
        description:
          "Receive a booking request, and accept or decline depending on availabilty",
      },
      {
        src: require("@/assets/fontawesome/circle-3-light.svg"),
        title: "Booking Finalization",
        description:
          "Both user accounts are verified, booking dates will be finalized and payment made via secure PayFast link",
      },
    ],
    features1: [
      {
        src: require("@/assets/fontawesome/circle-4-light.svg"),
        title: "Delivery and Payment",
        description:
          "Delivery is arranged between the item owner and borrower and rental fee paid out to the item owner.",
      },
      {
        src: require("@/assets/fontawesome/circle-5-light.svg"),
        title: "Save Time",
        description:
          "The item is used and we will notify you when it is to be returned",
      },
      {
        src: require("@/assets/fontawesome/circle-6-light.svg"),
        title: "Rating and Review",
        description:
          "Once the item and safety deposit is returned each user will rate and review their overall experience",
      },
    ],

    snackbar: true,
    text: `Hello, This website uses cookies to ensure you get the best experience on our website 🍪 👮`,
    partners: [
      {
        icon: "fas fa-people",
        title: "Trusted Partners",
        text: "We've teamed up with the best in the business",
      },
    ],
    awards: [
      {
        // src: require('@/assets/svgs/champagne.svg'),
        icon: "fas fa-trophy",
        title: "Awards and Accolades",
        text: "",
      },
    ],
    cards: [
      {
        src: require("@/assets/svgs/happy.svg"),
        icon: "fas fa-handshake",
        title: "Participate",
        text: " Be part of a community of people that encourage shared ownership, living flexibly and the environment.",
      },
      {
        src: require("@/assets/svgs/mindmap-1.svg"),
        icon: "fas fa-coins",
        title: "Access More",
        text: "Access more from people in your local community. Get what you need, for a fraction of the cost.",
      },
      {
        src: require("@/assets/svgs/money-3.svg"),
        icon: "fas fa-money-bill-wave",
        title: "Make More",
        text: "Turn the things you hardly use into income generating machines! Make passive income by doing hardly anything!",
      },
      {
        icon: "fas fa-tree",
        src: require("@/assets/svgs/grow-1.svg"),
        title: "Reduce waste",
        text: "Decrease the demand for mass produced goods by using what others already own.",
      },
    ],
  }),

  // created() {
  //   firebase.auth().onAuthStateChanged((user) => {
  //     this.authUser = user;
  //     if (user) {
  //       this.displayName = user.displayName;
  //       this.photoURL = user.photoURL;
  //       this.email = user.email;
  //       firebase
  //         .firestore()
  //         .collection("users")
  //         .doc(user.uid)
  //         .get()
  //         .then((snap) => {
  //           this.userDataFromDB = snap.data();
  //           if (this.userDataFromDB && this.userDataFromDB.verified) {
  //             this.$emit("profileVerified", true);
  //           }
  //         });
  //     }
  //   });
  //   var vm = this;
  //   firebase.auth().onAuthStateChanged(function (user) {
  //     if (user) {
  //       vm.user = user;
  //       vm.name = firebase.auth().currentUser.displayName;
  //       vm.email = vm.user.email;
  //       vm.photoURL = vm.user.photoURL;
  //       vm.userId = vm.user.uid;
  //     }
  //   });
  // },

  watch: {
    user(value) {
      if ((value !== null && value !== undefined) || value[0] !== null) {
        console.log(value);
        console.log("user logged in");
        this.$emit("loggedIn");
      }
    },
  },

  computed: {
    user() {
      return this.$store.getters.user;
    },
    minHeight() {
      const height = this.$vuetify.breakpoint.mdAndUp ? "100vh" : "50vh";

      return `calc(${height} - ${this.$vuetify.application.top}px)`;
    },
    items() {
      return this.$store.getters.loadedItems;
    },
    loading() {
      return this.$store.getters.loading;
    },
    userIsAuthenticated() {
      return (
        this.$store.getters.user !== null &&
        this.$store.getters.user !== undefined
      );
    },
  },

  methods: {
    onLoadItem(id) {
      this.$router.push("/items/" + id);
    },

    // Seen() {
    //   return (
    //     this.$store.getters.user !== null &&
    //     this.$store.getters.user !== undefined
    //   );
    // }
  },

  props: {
    id: {
      type: String,
      default: "home",
    },
  },
};
</script>

<template>
  <section id="hero" style="margin-top: 78px">
    <!-- <v-snackbar v-model="snackbar">
      {{ text }}

      <template v-slot:action="{ attrs }">
        <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">
          Got it!
        </v-btn>
      </template>
    </v-snackbar> -->

    <v-container class="fill-height px-1 py-9" style="z-index: 4">
      <v-slide-x-reverse-transition appear>
        <v-row style="z-index: 3">
          <v-col
            class="mt-lg-16"
            cols="12"
            sm="12"
            xs="12"
            md="6"
            lg="6"
            xl="6"
          >
            <v-img
              style="z-index: 3"
              height="70px"
              width="100px"
              :src="require('@/assets/logos/icon1.svg')"
              contain
              class="mt-8 hidden-sm-and-down"
            />
            <!-- <base-body> -->
            <v-row class="hidden-md-and-up">
              <v-col cols="2">
                <v-img
                  height="70px"
                  width="100px"
                  style="z-index: 4"
                  :src="require('@/assets/logos/icon1.svg')"
                  contain
                  class="ml-3 mt-8 hidden-md-and-up"
                />
              </v-col>
              <v-col cols="10">
                <p
                  style="
                    margin-top: 20px;
                    color: rgb(34, 34, 34);
                    font-display: swap;
                    z-index: 5;
                  "
                  :class="[
                    $vuetify.breakpoint.mdAndUp ? 'text-h1' : 'headline',
                  ]"
                  color="rgb(34, 34, 34)"
                  class="pa-1 ml-2 font-weight-bold"
                >
                  Earn money from renting out what you hardly use to others in
                  your community!
                </p>
              </v-col>
            </v-row>

            <p
              style="
                margin-top: 20px;
                color: rgb(34, 34, 34);
                font-display: swap;
                z-index: 5;
              "
              :class="[$vuetify.breakpoint.mdAndUp ? 'display-1' : 'headline']"
              color="rgb(34, 34, 34)"
              class="pa-3 font-weight-bold hidden-sm-and-down"
            >
              <!-- What do we do... <br /> -->
              Earn an income from renting out what you hardly use to others in
              your community!
            </p>
            <!-- <p style="color: white;" class="hidden subtitle-1">
                Rent out the things you own, but hardly use, to others for
                short-term periods. Increasing income and access.
              </p> -->

            <p
              class="pa-2"
              color="rgb(34, 34, 34)"
              style="font-size: 18px !important; font-display: swap; z-index: 4"
            >
              A central rental marketplace providing easy, affordable, and
              trusted rentals from your local community!
            </p>
            <v-btn
              class="hero-button hidden-sm-and-down font-weight-bold white--text"
              rounded
              color="secondary"
              elevation="8"
              large
              @click="$root.$refs.AppBar.openListingDialog();"
            >
              <v-icon x-small class="mr-1 text-none">fas fa-plus</v-icon> Add
              Item
            </v-btn>

            <!-- <v-btn
                v-bind="size"
                class="hidden-sm-and-down appbutton mx-1 mt-1 white--text font-weight-medium"
                color="#B22AF0"
                rounded
                elevation="6"
                to="/items/new"
                z-index="12"
              >
                <v-icon x-small class="mr-1">fas fa-plus</v-icon>Add Item</v-btn
              > -->

            <!-- <span class="font-weight-bold ml-6 mr-4 my-4">or</span> -->

            <v-btn
              to="/items"
              elevation="8"
              class="hero-button hidden-sm-and-down pa-1 ml-4 app--text"
              large
              rounded
            >
              <v-icon x-small class="pr-1">fas fa-search</v-icon>Browse
            </v-btn>
            <!-- </base-body> -->
          </v-col>

          <v-col cols="12" sm="12" xs="12" md="6" lg="6" xl="6">
            <v-img
              :src="require('@/assets/landing/hero1.png')"
              style="z-index: 3"
            ></v-img>
          </v-col>
        </v-row>
      </v-slide-x-reverse-transition>
    </v-container>

    <center>
      <div>
        <v-col>
          <v-row style="display: grid; place-items: center" class="mr-16 pr-16">
            <v-btn
              class="hidden-md-and-up white--text font-weight-black"
              rounded
              color="accent"
              elevation="8"
              large
              style="z-index: 99"

              @click="$root.$refs.AppBar.openListingDialog();"
              fixed
              medium
              bottom
              right
            >
              List an Item.
            </v-btn>
          </v-row>
        </v-col>
      </div>
    </center>

    <!-- <tilt></tilt> -->
    <!-- <v-parallax dark src="@/assets/bgHero1.png" height="550"> -->
    <v-responsive class="mx-auto pl-5 pr-5" max-width="1750">
      <v-container fluid>
        <v-row class="mb-4 mr-4 ml-4">
          <v-col
            v-for="card in cards"
            :key="card.title"
            cols="12"
            sm="3"
            md="3"
          >
            <base-info-card align="center" dark v-bind="card" />
          </v-col>
        </v-row>
      </v-container>
    </v-responsive>

    <v-sheet class="pt-8 pt-lg-16">
      <div class="text-center">
        <!-- <div
          class="text-uppercase font-weight-bold body-2 secondary--text mb-2"
        >
          How it works
        </div> -->
        <h2
          style="font-weight: 400 !important; color: rgb(34, 34, 34) !important"
          class="text-h4 text-lg-h4"
        >
          Earn money from your things
        </h2>
      </div>
      <v-row
        :class="$vuetify.breakpoint.mdAndUp ? 'pl-16' : ''"
        class="mt-10"
        max-width="1250"
      >
        <v-col cols="12" md="6" sm="12" xs="12" lg="5" offset-lg="1">
          <div class="pa-3" v-for="(item, i) in features" :key="i">
            <div class="d-flex">
              <div class="mr-2">
                <v-sheet class="pa-2 mt-1">
                  <v-img :src="item.src"></v-img>
                </v-sheet>
              </div>
              <div>
                <div class="text-h6">{{ item.title }}</div>
                <div class="text-subtitle-1 mt-1">
                  {{ item.description }}
                </div>
              </div>
            </div>
          </div>
        </v-col>
        <v-col
          :class="[$vuetify.breakpoint.mdAndUp ? '' : '']"
          :style="$vuetify.breakpoint.mdAndUp ? 'margin-top: 120px;' : ''"
          cols="12"
          md="6"
          sm="12"
          xs="12"
          lg="5"
        >
          <div class="pa-3" v-for="(item, i) in features1" :key="i">
            <div class="d-flex">
              <div class="mr-2">
                <v-sheet color="surface" rounded class="pa-2">
                  <v-img :src="item.src"></v-img>
                </v-sheet>
              </div>
              <div>
                <div class="text-h6">{{ item.title }}</div>
                <div class="text-subtitle-1 mt-1">{{ item.description }}</div>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-sheet>

    <center>
      <v-btn
        v-if="!userIsAuthenticated"
        @click.stop="signupDialog = true"
        x-large
        style="border-radius: 12px"
        class="white--text mb-7 app"
        >Sign Up
        <v-img
          class="ml-3"
          :src="require('@/assets/fontawesome/user-plus-duotone.svg')"
        />
      </v-btn>
    </center>

    <v-dialog
      v-model="signupDialog"
      scrollable
      :overlay="false"
      max-width="568px"
      transition="dialog-transition"
    >
      <SignupComponent
        :shouldRedirect="true"
        :addItem="false"
        @loggedIn="signupDialog = false"
        :fromPage="true"
        @changeDialog="
          signupDialog = false;
          loginDialog = true;
        "
      >
        <v-icon @click="signupDialog = false" class="exit">mdi-close</v-icon>
      </SignupComponent>
    </v-dialog>

    <v-dialog
      v-model="loginDialog"
      scrollable
      :overlay="false"
      max-width="568px"
      transition="dialog-transition"
    >
      <LoginComponent
        :shouldRedirect="false"
        :fromPage="true"
        :addItem="false"
        @loggedIn="loginDialog = false"
        @changeDialog="
          loginDialog = false;
          signupDialog = true;
        "
      />
    </v-dialog>

    <v-row style="padding-top: 16px" justify="center">
      <v-col v-for="card in partners" :key="card.title" cols="12" sm="3" md="3">
        <base-info-card align="center" dark v-bind="card" />
      </v-col>
    </v-row>

    <v-row justify="center" style="padding: 8px; margin-bottom: 36px">
      <v-col class="center" cols="6" xs="6" sm="6" md="6" lg="2" xl="2">
        <v-img class="pimg" :src="require('@/assets/partnerLogos/stitch.jpg')">
        </v-img>
      </v-col>

      <v-col class="center" cols="6" xs="6" sm="6" md="6" lg="2" xl="2">
        <v-img
          class="pimg"
          :src="require('@/assets/partnerLogos/payfast.jpeg')"
        >
        </v-img>
      </v-col>

      <v-col class="center" cols="6" xs="6" sm="6" md="6" lg="4" xl="4">
        <v-img class="pimg" :src="require('@/assets/partnerLogos/genric.jpg')">
        </v-img>
      </v-col>
      <v-col class="center" cols="6" xs="6" sm="6" md="6" lg="2" xl="2">
        <v-img
          class="pimg"
          :src="require('@/assets/partnerLogos/innovation.jpg')"
        >
        </v-img>
      </v-col>
      <v-col class="center" cols="6" xs="6" sm="6" md="6" lg="2" xl="2">
        <v-img class="pimg" :src="require('@/assets/partnerLogos/sab.jpg')">
        </v-img>
      </v-col>
    </v-row>

    <v-sheet class="d-flex flex-column">
      <svg
        class="logos-bg"
        style="fill: #fff"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1442 163"
      >
        <path
          d="m-3.90909,6l48.30303,16c48.30303,16 144.90908,48 241.51514,48c96.60606,0 193.21211,-32 289.81817,-32c96.60606,0 193.21211,32 289.81817,53.3c96.60606,21.7 193.21211,31.7 289.81817,16c96.60606,-16.3 193.21211,-58.3 241.51514,-80l48.30303,-21.3l0,160l-48.30303,0c-48.30303,0 -144.90908,0 -241.51514,0c-96.60606,0 -193.21211,0 -289.81817,0c-96.60606,0 -193.21211,0 -289.81817,0c-96.60606,0 -193.21211,0 -289.81817,0c-96.60606,0 -193.21211,0 -241.51514,0l-48.30303,0l0,-160z"
        />
      </svg>
    </v-sheet>

    <div class="text-center mt-n16">
      <!-- <div class="text-uppercase font-weight-bold body-2 secondary--text mb-2">
        Items
      </div> -->
      <h2
        style="font-weight: 400 !important; color: rgb(34, 34, 34) !important"
        class="text-h4 text-lg-h4 mb-6 mt-6"
      >
        Some of what we have:
      </h2>
    </div>

    <explore-items></explore-items>

    <div class="text-center">
      <!-- <div class="text-uppercase font-weight-bold body-2 secondary--text mb-2">
        Items
      </div> -->
      <h2
        style="font-weight: 400 !important; color: rgb(34, 34, 34) !important"
        class="text-h4 text-lg-h4 mb-6 mt-16"
      >
        Looking for something we don't have? Ask the community!
      </h2>
    </div>

    <div class="text-center my-8">
      <v-btn
        to="/new/request"
        @click="trackClick(item)"
        x-large
        style="border-radius: 12px"
        class="white--text mb-7 app"
        id="requests-btn-home"
      >
        <v-img
          class="mr-3"
          width="20px"
          height="20px"
          :src="require('@/assets/fontawesome/square-question-duotone.svg')"
        />Request an item
      </v-btn>
    </div>

    <trees></trees>

    <requests-carousel></requests-carousel>

    <v-row style="padding-top: 16px" justify="center">
      <v-col v-for="card in awards" :key="card" cols="12" sm="3" md="3">
        <base-info-card align="center" dark v-bind="card" />
      </v-col>
    </v-row>

    <v-row style="padding: 8px; margin-bottom: 36px !important">
      <v-col class="center" cols="12" sm="6" md="6" lg="4" xl="4">
        <v-img
          class="img"
          :src="require('@/assets/partnerLogos/etrack.png')"
          contain
        >
        </v-img>
        <h6 class="text-subtitle-1 mt-1" style="text-align: center">
          <i
            >Most likely to succeed 2022 UCT GSB E-Track Accelerator Programme -
            Peer Award</i
          >
        </h6>
      </v-col>

      <v-col class="center" cols="12" sm="6" md="6" lg="4" xl="4">
        <v-img
          class="img"
          :src="require('@/assets/partnerLogos/akro.png')"
          contain
        >
        </v-img>
        <h6 class="text-subtitle-1 mt-1" style="text-align: center">
          <i>Competition winner of the 2021 Akro Africa Leopards Lair Pitch </i>
        </h6>
      </v-col>

      <v-col class="center" sm="6" md="6" lg="4" xl="4">
        <v-img
          class="img"
          :src="require('@/assets/partnerLogos/gsb.png')"
          contain
        >
        </v-img>
        <h6 class="text-subtitle-1 mt-1" style="text-align: center">
          <i>Top 7 of Cohort 5 2022 UCT GSB E-Track Accelerator Programme</i>
        </h6>
      </v-col>
    </v-row>

    <v-sheet color="#fff">
      <div class="text-center">
        <!-- <div
          class="text-uppercase font-weight-bold body-2 secondary--text mb-2"
        >
          why choose us
        </div> -->
        <h2
          style="font-weight: 400 !important; color: rgb(34, 34, 34) !important"
          class="text-h4 text-lg-h4 mb-5 mt-16"
        >
          Strapp makes it possible for you to
        </h2>
      </div>
      <v-container class="py-4 py-lg-8 mt-13">
        <v-row>
          <v-col cols="12" md="9" lg="8" xl="6" offset-lg="1">
            <v-row>
              <v-img
                :src="require('@/assets/landing/money.png')"
                max-width="280"
                max-height="280"
              ></v-img>
              <v-col>
                <div
                  :class="$vuetify.breakpoint.mdAndUp ? 'ml-8' : ''"
                  class="text-h5 secondary--text text-lg-h5"
                >
                  <strong> Get paid for what you already own! </strong>
                </div>
                <br />
                <p
                  :class="$vuetify.breakpoint.mdAndUp ? 'ml-8' : ''"
                  style="font-weight: 400 !important; font-style: Italic"
                >
                  Remember your lawnmower you only use once every 2 weeks?
                  <br />
                  Instead of letting it waste away when you arent using it, rent
                  it out to other community members and make money in the
                  process!
                </p>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-col cols="12" md="10" lg="7" offset-md="2" offset-lg="4">
          <v-row>
            <v-img
              :src="require('@/assets/landing/fly.png')"
              max-width="280"
              max-height="280"
            ></v-img>
            <v-col>
              <div
                :class="$vuetify.breakpoint.mdAndUp ? 'ml-8' : ''"
                class="secondary--text text-h5 text-lg-h5"
              >
                <strong> Own less. Access More </strong>
              </div>
              <br />
              <p
                :class="$vuetify.breakpoint.mdAndUp ? 'ml-8' : ''"
                style="
                  font-weight: 400 !important;
                  font-style: Italic;
                  font-size: 18px !important;
                "
              >
                Do what you otherwise couldn't with flexible ownership, allowing
                you quick and easy access to the things you need, when you need
                them, accessing more for less.
              </p>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="9" lg="7" offset-lg="1">
          <v-row>
            <v-img
              :src="require('@/assets/landing/rating.png')"
              max-width="280"
              max-height="280"
            ></v-img>
            <v-col>
              <div
                :class="$vuetify.breakpoint.mdAndUp ? 'ml-8' : ''"
                class="secondary--text text-h5 text-lg-h5"
              >
                <strong> Transact Safely </strong>
              </div>
              <br />
              <p
                :class="$vuetify.breakpoint.mdAndUp ? 'ml-8' : ''"
                style="
                  font-weight: 400 !important;
                  font-style: Italic;
                  font-size: 18px !important;
                "
              >
                Supporting you every step of the way by creating tranparency in
                every transaction, thats why all our users go under a thorough
                verification process.
              </p>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="9" lg="7" offset-md="3" offset-lg="5">
          <v-row>
            <v-img
              :src="require('@/assets/landing/community.png')"
              max-width="280"
              max-height="280"
            ></v-img>
            <v-col>
              <div
                :class="$vuetify.breakpoint.mdAndUp ? 'ml-8' : ''"
                class="secondary--text text-h5 text-lg-h5"
              >
                <strong> Build connected communities</strong>
              </div>
              <br />
              <p
                :class="$vuetify.breakpoint.mdAndUp ? 'ml-8' : ''"
                style="
                  font-weight: 400 !important;
                  font-style: Italic;
                  font-size: 18px !important;
                "
              >
                Creating communities built upon flexibility, shared ownership
                and trust, allowing you to access what you need form others in
                your area. Connecting people, experiences and redefining
                ownership.
              </p>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="9" lg="7" offset-lg="1">
          <v-row>
            <v-img
              :src="require('@/assets/landing/enviro.png')"
              max-width="280"
              max-height="280"
            ></v-img>
            <v-col>
              <div
                :class="$vuetify.breakpoint.mdAndUp ? 'ml-8' : ''"
                class="secondary--text text-h5 text-lg-h5"
              >
                <strong> Help the enviroment</strong>
              </div>
              <br />
              <p
                :class="$vuetify.breakpoint.mdAndUp ? 'ml-8' : ''"
                style="
                  font-weight: 400 !important;
                  font-style: Italic;
                  font-size: 18px !important;
                "
              >
                You can save an estimated 350kg of C02 from listing a laptop for
                rent. This is the equivalent of driving 1255 km!
                <br />
                Renting reduces the demand for mass produced goods, helping the
                enviroment as well as your pocket!
              </p>
            </v-col>
          </v-row>
        </v-col>
      </v-container>
    </v-sheet>

    <customer-reviews></customer-reviews>

    <div class="text-center">
      <!-- <div
        class="text-uppercase mt-12 font-weight-bold body-2 secondary--text mb-2"
      >
        Stay Informed
      </div> -->
      <h2
        style="font-weight: 400 !important; color: rgb(34, 34, 34) !important"
        class="text-h4 text-lg-h4"
      >
        Get the latest info about Strapp
      </h2>
    </div>

    <subscribe style="margin-bottom: 120px" class="mx-auto" max-width="700" />
    <!-- <instagram-embed
      :url="'https://www.instagram.com/strapprsa/'"
      :max-width="500"
    /> -->
  </section>
</template>

<style lang="scss" scoped>
.c-preview {
  background: white;
  background: -moz-linear-gradient(
    -45deg,
    white 0%,
    #000000 25%,
    #1e539e 50%,
    #ff3083 75%,
    #7800a8 100%
  );
  /* FF3.6-15 */
  background: -webkit-linear-gradient(
    -45deg,
    #000000 0%,
    #000000 25%,
    #1e539e 50%,
    #ff3083 75%,
    #7800a8 100%
  );
  /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(
    135deg,
    #000000 0%,
    #000000 25%,
    #1e539e 50%,
    #ff3083 75%,
    #7800a8 100%
  );
  /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  background-size: 400% 400%;
  background-repeat: no-repeat;
  transition: 0.5s all;

  &:hover {
    background-position: 100% 100%;
  }
}

.zoom-efect {
  transform: scale(1.2);
}

.up {
  transform: translateY(-20px);
  transition: 0.3s ease-out;
}

.center {
  display: grid;
  place-items: center;
}

.example-3d {
  width: 100%;
  height: 400px;
  padding-top: 50px;
  padding-bottom: 50px;
}

.swiper {
  height: 100%;
  width: 100%;
  border-radius: 20px;

  .swiper-slide {
    display: flex;
    border-radius: 20px;
    justify-content: center;
    align-items: center;
    width: 300px;
    height: 300px;
    text-align: center;

    font-weight: bold;
    // font-size: $font-size-large * 2;
    background-color: whitesmoke;
    background-position: center;
    background-size: cover;
    color: white;
  }

  .swiper-pagination {
    .swiper-pagination-bullet.swiper-pagination-bullet-active {
      background-color: white;
      margin-top: 50px;
    }
  }
}

.vsc-popup-button {
  background-color: var(--vsc-bg-button);
  bottom: 30%;
}

.whatsapp-chat {
  --whatsapp: #46c056;
  --vsc-bg-header: var(--whatsapp);
  --vsc-bg-button: var(--whatsapp);
  --vsc-outline-color: var(--whatsapp);
}

.hero-button {
  padding: 1rem 4rem;
  border-radius: 100rem;
  color: white;
  width: 10rem;
  font-weight: 700;
  transition: 0.5s;
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease 0s;
}

.hero-button:hover {
  width: 11rem;
  box-shadow: 0px 15px 20px rgba(46, 229, 157, 0.4);
  transform: translateY(-7px);
}

/* .svg-border-waves .v-image {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3rem;
  width: 100%;
  overflow: hidden;
}
.svg-border-waves img {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  margin-bottom: -2px;
  z-index: 2;
} */

/*Particle BG Effect*/

.particle-bg {
  position: absolute;
  top: 2%;
  left: 80%;
  z-index: 2;
}

.particle-bg img {
  animation: spin 27s linear infinite;
}

@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}

.background-shape {
  position: absolute;
  animation-name: bobbingAnim;
  animation-duration: 2s;
  padding: 0 7px 7px;
  top: 75%;

  animation-iteration-count: infinite;
  animation-play-state: running;
}

@keyframes bobbingAnim {
  0% {
    transform: translate(0px, 0px);
    animation-timing-function: ease-in-out;
  }

  50% {
    transform: translate(0px, 14px);
    animation-timing-function: ease-in-out;
  }

  100% {
    transform: translate(0px, 0px);
    animation-timing-function: ease-in-out;
  }
}

.background-shape img {
  max-width: 90%;
}

.img {
  /* height: auto; */
  max-height: 70px !important;
  width: auto;
}

.pimg {
  /* height: auto; */
  max-height: 100px !important;
  max-width: 100px;
}
</style>
